export default Object.freeze({
  UserJoinChat: 1,
  UserMessage: 2,
  UserCloseChat: 3,
  AgentCloseChat: 4,
  SystemCloseChat: 5,
  Response: 6,
  AgentAssigned: 7,
  AgentTyping: 8,
  AIThinking: 9,
  ThreadStatusChange: 10,
  ChatTaskRun: 11,
  TaskStatusChange: 12,
  EngineAIMessage: 13,
  EmailMessage: 14,
  ThreadTitleChange: 15,
  UserLeaveChat: 16,
  WhatsAppMessage: 17,
});
